
import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const uploadImage = async payload => await AxiosService.postFile(Config.server.api.filesApi + `user/avatar`, payload, true);

export default {
    uploadImage
}